import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as IconTooltip } from '../resources/icons_Tooltip.svg';

const Tooltip = ({ alt, children }) => {
    const [isShown, show] = React.useState(false);
    return (
        <span className="wz-lyriapay-payline-tooltip">
            <IconTooltip
                alt={alt}
                className="wz-lyriapay-payline-tooltip"
                onClick={() => show(!isShown)}
            />
            <div
                className="wz-lyriapay-payline-tooltipcontent"
                aria-hidden={isShown}
                role="tooltip"
                style={{ visibility: isShown ? 'visible' : 'hidden' }}
            >
                {children}
            </div>
        </span>
    );
};

Tooltip.propTypes = {
    children: PropTypes.node.isRequired,
    alt: PropTypes.string.isRequired
};

export default Tooltip;
